import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { AppText } from "@toothfairy/shared-ui";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet, View } from "react-native";
import { isLargeScreen } from "../Screens/MainViewContainer";
import Constants from "../Constants";
import ToothFairyButton from "./ToothFairyComponents/ToothFairyButton";
import ToothFairyModal from "./ToothFairyComponents/ToothFairyModal";

const NewsletterConsentModal = ({
  visible,
  setVisible,
  onAccept,
  onDecline,
  isUpdating,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  const renderTerms = () => {
    const terms = Constants.newsletterConsent.terms;
    return [
      { key: "what", text: t(terms.what) },
      { key: "who", text: t(terms.who) },
      { key: "howLong", text: t(terms.howLong) },
      { key: "howWithdraw", text: t(terms.howWithdraw) },
    ];
  };

  return (
    <ToothFairyModal
      modalStyle={{
        height: "auto",
        width: "90%",
        maxWidth: isLargeScreen() ? 600 : 350,
        marginHorizontal: "auto",
        marginTop: "auto",
        marginBottom: "auto",
        margin: "auto",
      }}
      isModalOpen={visible}
      setIsModalOpen={setVisible}
      modalTitle={t("newsletter.title")}
      closeModal={() => {
        // Treat the X / escape as a decline (once-only flag still gets set).
        onDecline?.();
      }}
    >
      <View
        style={[
          styles.container,
          { backgroundColor: currentTheme?.theme?.backgroundColor },
        ]}
      >
        <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
          <AppText
            style={{
              fontSize: currentTheme?.theme?.small_font_size,
              marginBottom: 16,
              textAlign: "center",
            }}
            color={currentTheme?.theme?.font_color}
          >
            {t("newsletter.subtitle")}
          </AppText>

          <AppText
            style={{
              fontSize: currentTheme?.theme?.small_font_size,
              marginBottom: 12,
              fontWeight: "bold",
            }}
            color={currentTheme?.theme?.font_color}
          >
            {t("newsletter.termsIntro")}
          </AppText>

          <View style={styles.termsContainer}>
            {renderTerms().map((term) => (
              <AppText
                key={term.key}
                style={{
                  fontSize: currentTheme?.theme?.small_font_size,
                  marginBottom: 8,
                }}
                color={currentTheme?.theme?.font_color}
              >
                {"\u2022 " + term.text}
              </AppText>
            ))}
          </View>
        </ScrollView>

        <View style={styles.footer}>
          <ToothFairyButton
            title={t("newsletter.yes")}
            onPress={onAccept}
            isDisabled={isUpdating}
            buttonStyle={styles.button}
            primary
            paddingLeft={10}
            paddingRight={10}
          />
          <AppText
            isClickable={!isUpdating}
            onPress={onDecline}
            color={currentTheme?.theme?.red}
            wrapperStyle={{
              marginTop: 10,
            }}
          >
            {t("newsletter.no")}
          </AppText>
        </View>
      </View>
    </ToothFairyModal>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    padding: 24,
  },
  content: {
    flex: 1,
    marginBottom: 20,
  },
  termsContainer: {
    paddingLeft: 4,
  },
  footer: {
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "rgba(0,0,0,0.1)",
    alignItems: "center",
  },
  button: {
    paddingVertical: 12,
    minWidth: 200,
  },
});

export default NewsletterConsentModal;
